import React from "react";
import classNames from "classnames";
import Badge from "../../theme/untitled/Badge/Badge";
import Icon from "../../theme/untitled/icons/Icon";
import { formatDateShort } from "../../../../helpers/formatters";
import styles from "./Table.module.scss";

const TableRow = ({ domain, renderMenu, isBusy = false }) => {
  const isPaused = !domain.available;
  const addedDate = domain.created ? formatDateShort(domain.created * 1000) : "—";
  const addedBy = domain.creator?.name || domain.creator?.email || null;
  const addedMeta = addedBy ? `Added ${addedDate} · ${addedBy}` : `Added ${addedDate}`;

  const statusBadge = isBusy ? (
    <Badge color="gray" size="sm">
      <span className={styles.spinner} aria-hidden="true" />
      {isPaused ? "Resuming…" : "Pausing…"}
    </Badge>
  ) : (
    isPaused && (
      <Badge color="gray" size="sm">
        Paused
      </Badge>
    )
  );

  return (
    <tr className={classNames(styles.row, { [styles["row--busy"]]: isBusy })}>
      <td className={styles.td}>
        <div className={styles.domainCell}>
          <span
            className={classNames(styles.iconDisc, { [styles["iconDisc--paused"]]: isPaused })}
            aria-hidden="true"
          >
            <Icon name="GlobeSlated01" size={20} />
          </span>
          <span className={styles.domainText}>
            <span className={styles.domainName}>{domain.domain}</span>
            <span className={styles.mobileMeta}>
              {statusBadge}
              <span className={styles.mobileAdded}>{addedMeta}</span>
            </span>
          </span>
        </div>
      </td>
      <td className={classNames(styles.td, styles.statusCell)}>
        {isBusy || isPaused ? statusBadge : <span className={styles.activeLabel}>Active</span>}
      </td>
      <td className={classNames(styles.td, styles.addedCell)}>
        <span className={styles.addedDate}>{addedDate}</span>
        {addedBy && <span className={styles.addedBy}>by {addedBy}</span>}
      </td>
      <td className={classNames(styles.td, styles.actionsCell)}>
        {!isBusy && renderMenu(domain)}
      </td>
    </tr>
  );
};

export default TableRow;
